import hljs from 'highlight.js/lib/core'
import javascript from 'highlight.js/lib/languages/javascript'
import go from 'highlight.js/lib/languages/go'
import python from 'highlight.js/lib/languages/python'
import java from 'highlight.js/lib/languages/java'
import html from 'highlight.js/lib/languages/xml'
import css from 'highlight.js/lib/languages/css'
import typescript from 'highlight.js/lib/languages/typescript'
import bash from 'highlight.js/lib/languages/bash'
import json from 'highlight.js/lib/languages/json'
import php from 'highlight.js/lib/languages/php'
import highlightJS from '@highlightjs/vue-plugin'
import 'highlight.js/styles/atom-one-dark.css'

export default defineNuxtPlugin((nuxtApp) => {
    // Register the languages
    hljs.registerLanguage('javascript', javascript)
    hljs.registerLanguage('js', javascript)
    hljs.registerLanguage('go', go)
    hljs.registerLanguage('golang', go)
    hljs.registerLanguage('python', python)
    hljs.registerLanguage('java', java)
    hljs.registerLanguage('html', html)
    hljs.registerLanguage('css', css)
    hljs.registerLanguage('typescript', typescript)
    hljs.registerLanguage('ts', typescript)
    hljs.registerLanguage('bash', bash)
    hljs.registerLanguage('json', json)
    hljs.registerLanguage('php', php)

    // Use the highlight.js Vue plugin
    nuxtApp.vueApp.use(highlightJS)
})
